// src/contexts/AuthContext.jsx
import React, { createContext, useContext, useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../services/firebase';
import { getAccountId } from '../services/accountService';
import LoadingSpinner from '../components/LoadingSpinner'; // ローディングスピナーをインポート

const AuthContext = createContext(undefined);

export const AuthProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState(null);
    const [accountId, setAccountId] = useState(null);
    const [loading, setLoading] = useState(true); // 認証状態の読み込みが完了するまでtrue

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            setCurrentUser(user);

            if (user) {
                try {
                    // ユーザーがログインしている場合、アカウントIDを取得
                    const userAccountId = await getAccountId(user.uid);
                    setAccountId(userAccountId);
                } catch (error) {
                    console.error('アカウントID取得エラー:', error);
                    // エラーの場合はユーザーIDをアカウントIDとして使用
                    setAccountId(user.uid);
                }
            } else {
                setAccountId(null);
            }

            setLoading(false); // 認証状態の読み込みが完了
        });

        return unsubscribe; // クリーンアップ関数
    }, []);

    if (loading) {
        return <LoadingSpinner />; // 認証状態の読み込み中はローディングスピナーを表示
    }

    return (
        <AuthContext.Provider value={{ currentUser, accountId, loading }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (context === undefined) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};